<!--
 * @Author: 忠于自己 429022021@qq.com
 * @Date: 2025-07-07 11:19:07
 * @LastEditors: 忠于自己 429022021@qq.com
 * @LastEditTime: 2025-07-17 13:32:26
 * @FilePath: \duilvpcbase\src\views\originality\children\createQE\components\newAsideRight.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="aside-p">
    <div class="aside-cover-p"
         @click="scrollToCover">
      <div></div>
      <p>基础检查</p>
    </div>
    <div class="aside-scene-p"
         style="height: 78px;text-align:center;"
         @click="scrollToScene">
      <div></div>
      <p>现场标样制作</p>
    </div>
    <div class="aside-quality-p"
         style="height: 78px;text-align:center;"
         @click="scrollToQuality">
      <div></div>
      <p>原材料进场</p>
    </div>
    <div class="aside-material-p"
         style="height: 78px;text-align:center;"
         @click="scrollToMaterial">
      <div></div>
      <p>施工过程管控</p>
    </div>
    <div class="aside-extrinsic-p"
         @click="scrollToExtrinsic">
      <div></div>
      <p>外部因素</p>
    </div>
    <div class="aside-spot-p"
         @click="scrollToSpot">
      <div></div>
      <p>成品抽检</p>
    </div>
    <div class="aside-info-p"
         @click="scrollToInfo">
      <div></div>
      <p>信息反馈</p>
    </div>
    <div class="aside-top-p"
         @click="scrollToTop">
      <img src="../../../../../html/pages/originality/createQe/images/arrow1.png"
           alt="">
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/createQE/newAsideRight.scss";

export default {
  name: 'asideRight',
  methods: {
    scrollToCover () {
      this.$emit("scrollToCover")
    },
    scrollToScene () {
      this.$emit("scrollToScene")
    },
    scrollToQuality () {
      this.$emit("scrollToQuality")
    },
    scrollToMaterial () {
      this.$emit("scrollToMaterial")
    },
    scrollToExtrinsic () {
      this.$emit("scrollToExtrinsic")
    },
    scrollToSpot () {
      this.$emit("scrollToSpot")
    },
    scrollToInfo () {
      this.$emit("scrollToInfo")
    },
    scrollToTop () {
      this.$emit("scrollToTop")
    }
  }
}
</script>
